const NAME = 'CLEVERTAP';
const CNameMapping = {
  [NAME]: NAME,
  Clevertap: NAME,
  clevertap: NAME,
};

export { NAME, CNameMapping };
